import "./main.css";
import {useStyleProps as $011V3$useStyleProps, useDOMRef as $011V3$useDOMRef, classNames as $011V3$classNames} from "@react-spectrum/utils";
import {filterDOMProps as $011V3$filterDOMProps} from "@react-aria/utils";
import {useProviderProps as $011V3$useProviderProps, Provider as $011V3$Provider} from "@react-spectrum/provider";
import $011V3$react, {useContext as $011V3$useContext} from "react";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



var $cd231e464c886c86$exports = {};

$parcel$export($cd231e464c886c86$exports, "contextualHelp", () => $cd231e464c886c86$export$4ba534aba1836d, (v) => $cd231e464c886c86$export$4ba534aba1836d = v);
$parcel$export($cd231e464c886c86$exports, "field", () => $cd231e464c886c86$export$e0f35d825088c098, (v) => $cd231e464c886c86$export$e0f35d825088c098 = v);
$parcel$export($cd231e464c886c86$exports, "focus-ring", () => $cd231e464c886c86$export$f39a09f249340e2a, (v) => $cd231e464c886c86$export$f39a09f249340e2a = v);
$parcel$export($cd231e464c886c86$exports, "helpText", () => $cd231e464c886c86$export$431a3b688422af44, (v) => $cd231e464c886c86$export$431a3b688422af44 = v);
$parcel$export($cd231e464c886c86$exports, "i18nFontFamily", () => $cd231e464c886c86$export$8c4ee2c50c22c514, (v) => $cd231e464c886c86$export$8c4ee2c50c22c514 = v);
$parcel$export($cd231e464c886c86$exports, "is-disabled", () => $cd231e464c886c86$export$d35bc1e505d1ebbf, (v) => $cd231e464c886c86$export$d35bc1e505d1ebbf = v);
$parcel$export($cd231e464c886c86$exports, "label", () => $cd231e464c886c86$export$1237798dc640739a, (v) => $cd231e464c886c86$export$1237798dc640739a = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field", () => $cd231e464c886c86$export$f6d480ae1e56eba0, (v) => $cd231e464c886c86$export$f6d480ae1e56eba0 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--alignEnd", () => $cd231e464c886c86$export$5354c9be7ada5f83, (v) => $cd231e464c886c86$export$5354c9be7ada5f83 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--hasContextualHelp", () => $cd231e464c886c86$export$9ba23707a252cdd4, (v) => $cd231e464c886c86$export$9ba23707a252cdd4 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionSide", () => $cd231e464c886c86$export$2963225c91179589, (v) => $cd231e464c886c86$export$2963225c91179589 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionTop", () => $cd231e464c886c86$export$a4ea780a9064d7f9, (v) => $cd231e464c886c86$export$a4ea780a9064d7f9 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-contextualHelp", () => $cd231e464c886c86$export$24fb860d16dd2d3f, (v) => $cd231e464c886c86$export$24fb860d16dd2d3f = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-field", () => $cd231e464c886c86$export$3ab8a3dc7f0563d, (v) => $cd231e464c886c86$export$3ab8a3dc7f0563d = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-labelCell", () => $cd231e464c886c86$export$9cde5aecff012641, (v) => $cd231e464c886c86$export$9cde5aecff012641 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-labelWrapper", () => $cd231e464c886c86$export$a872a8c78b26c9e0, (v) => $cd231e464c886c86$export$a872a8c78b26c9e0 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-wrapper", () => $cd231e464c886c86$export$127df0b7290eb8ef, (v) => $cd231e464c886c86$export$127df0b7290eb8ef = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel", () => $cd231e464c886c86$export$493d18e796ae054, (v) => $cd231e464c886c86$export$493d18e796ae054 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--alignEnd", () => $cd231e464c886c86$export$885efcc08143a987, (v) => $cd231e464c886c86$export$885efcc08143a987 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--positionSide", () => $cd231e464c886c86$export$9e6f19dc21f22f2e, (v) => $cd231e464c886c86$export$9e6f19dc21f22f2e = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel-requiredIcon", () => $cd231e464c886c86$export$7c47642c7d46f3c9, (v) => $cd231e464c886c86$export$7c47642c7d46f3c9 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FocusRing-ring", () => $cd231e464c886c86$export$4109102f950813a6, (v) => $cd231e464c886c86$export$4109102f950813a6 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FocusRing", () => $cd231e464c886c86$export$24c7f46a6e3605dd, (v) => $cd231e464c886c86$export$24c7f46a6e3605dd = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FocusRing--quiet", () => $cd231e464c886c86$export$2927016961429360, (v) => $cd231e464c886c86$export$2927016961429360 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form", () => $cd231e464c886c86$export$94d2bcc94afabd89, (v) => $cd231e464c886c86$export$94d2bcc94afabd89 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionSide", () => $cd231e464c886c86$export$7f44db659563c8f4, (v) => $cd231e464c886c86$export$7f44db659563c8f4 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionTop", () => $cd231e464c886c86$export$11b8bc81fe551057, (v) => $cd231e464c886c86$export$11b8bc81fe551057 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form-itemLabel", () => $cd231e464c886c86$export$51ec27881a1e3928, (v) => $cd231e464c886c86$export$51ec27881a1e3928 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-LabeledValue", () => $cd231e464c886c86$export$79f9a5e9dd010c8d, (v) => $cd231e464c886c86$export$79f9a5e9dd010c8d = v);
var $cd231e464c886c86$export$4ba534aba1836d;
var $cd231e464c886c86$export$e0f35d825088c098;
var $cd231e464c886c86$export$f39a09f249340e2a;
var $cd231e464c886c86$export$431a3b688422af44;
var $cd231e464c886c86$export$8c4ee2c50c22c514;
var $cd231e464c886c86$export$d35bc1e505d1ebbf;
var $cd231e464c886c86$export$1237798dc640739a;
var $cd231e464c886c86$export$f6d480ae1e56eba0;
var $cd231e464c886c86$export$5354c9be7ada5f83;
var $cd231e464c886c86$export$9ba23707a252cdd4;
var $cd231e464c886c86$export$2963225c91179589;
var $cd231e464c886c86$export$a4ea780a9064d7f9;
var $cd231e464c886c86$export$24fb860d16dd2d3f;
var $cd231e464c886c86$export$3ab8a3dc7f0563d;
var $cd231e464c886c86$export$9cde5aecff012641;
var $cd231e464c886c86$export$a872a8c78b26c9e0;
var $cd231e464c886c86$export$127df0b7290eb8ef;
var $cd231e464c886c86$export$493d18e796ae054;
var $cd231e464c886c86$export$885efcc08143a987;
var $cd231e464c886c86$export$9e6f19dc21f22f2e;
var $cd231e464c886c86$export$7c47642c7d46f3c9;
var $cd231e464c886c86$export$4109102f950813a6;
var $cd231e464c886c86$export$24c7f46a6e3605dd;
var $cd231e464c886c86$export$2927016961429360;
var $cd231e464c886c86$export$94d2bcc94afabd89;
var $cd231e464c886c86$export$7f44db659563c8f4;
var $cd231e464c886c86$export$11b8bc81fe551057;
var $cd231e464c886c86$export$51ec27881a1e3928;
var $cd231e464c886c86$export$79f9a5e9dd010c8d;
$cd231e464c886c86$export$4ba534aba1836d = `A-HlBa_contextualHelp`;
$cd231e464c886c86$export$e0f35d825088c098 = `A-HlBa_field`;
$cd231e464c886c86$export$f39a09f249340e2a = `A-HlBa_focus-ring`;
$cd231e464c886c86$export$431a3b688422af44 = `A-HlBa_helpText`;
$cd231e464c886c86$export$8c4ee2c50c22c514 = `A-HlBa_i18nFontFamily`;
$cd231e464c886c86$export$d35bc1e505d1ebbf = `A-HlBa_is-disabled`;
$cd231e464c886c86$export$1237798dc640739a = `A-HlBa_label`;
$cd231e464c886c86$export$f6d480ae1e56eba0 = `A-HlBa_spectrum-Field`;
$cd231e464c886c86$export$5354c9be7ada5f83 = `A-HlBa_spectrum-Field--alignEnd`;
$cd231e464c886c86$export$9ba23707a252cdd4 = `A-HlBa_spectrum-Field--hasContextualHelp`;
$cd231e464c886c86$export$2963225c91179589 = `A-HlBa_spectrum-Field--positionSide`;
$cd231e464c886c86$export$a4ea780a9064d7f9 = `A-HlBa_spectrum-Field--positionTop`;
$cd231e464c886c86$export$24fb860d16dd2d3f = `A-HlBa_spectrum-Field-contextualHelp`;
$cd231e464c886c86$export$3ab8a3dc7f0563d = `A-HlBa_spectrum-Field-field`;
$cd231e464c886c86$export$9cde5aecff012641 = `A-HlBa_spectrum-Field-labelCell`;
$cd231e464c886c86$export$a872a8c78b26c9e0 = `A-HlBa_spectrum-Field-labelWrapper`;
$cd231e464c886c86$export$127df0b7290eb8ef = `A-HlBa_spectrum-Field-wrapper`;
$cd231e464c886c86$export$493d18e796ae054 = `A-HlBa_spectrum-FieldLabel`;
$cd231e464c886c86$export$885efcc08143a987 = `A-HlBa_spectrum-FieldLabel--alignEnd`;
$cd231e464c886c86$export$9e6f19dc21f22f2e = `A-HlBa_spectrum-FieldLabel--positionSide`;
$cd231e464c886c86$export$7c47642c7d46f3c9 = `A-HlBa_spectrum-FieldLabel-requiredIcon`;
$cd231e464c886c86$export$4109102f950813a6 = `A-HlBa_spectrum-FocusRing-ring`;
$cd231e464c886c86$export$24c7f46a6e3605dd = `A-HlBa_spectrum-FocusRing ${$cd231e464c886c86$export$4109102f950813a6}`;
$cd231e464c886c86$export$2927016961429360 = `A-HlBa_spectrum-FocusRing--quiet`;
$cd231e464c886c86$export$94d2bcc94afabd89 = `A-HlBa_spectrum-Form`;
$cd231e464c886c86$export$7f44db659563c8f4 = `A-HlBa_spectrum-Form--positionSide`;
$cd231e464c886c86$export$11b8bc81fe551057 = `A-HlBa_spectrum-Form--positionTop`;
$cd231e464c886c86$export$51ec27881a1e3928 = `A-HlBa_spectrum-Form-itemLabel`;
$cd231e464c886c86$export$79f9a5e9dd010c8d = `A-HlBa_spectrum-LabeledValue`;


let $ac118ceca79b8650$var$FormContext = /*#__PURE__*/ (0, $011V3$react).createContext(null);
function $ac118ceca79b8650$export$a6b5be5c6b451665(props) {
    let ctx = (0, $011V3$useContext)($ac118ceca79b8650$var$FormContext);
    if (ctx) return {
        ...ctx,
        ...props
    };
    return props;
}
const $ac118ceca79b8650$var$formPropNames = new Set([
    "action",
    "autoComplete",
    "encType",
    "method",
    "target",
    "onSubmit"
]);
function $ac118ceca79b8650$var$Form(props, ref) {
    props = (0, $011V3$useProviderProps)(props);
    let { children: children, labelPosition: labelPosition = "top", labelAlign: labelAlign = "start", isRequired: isRequired, necessityIndicator: necessityIndicator, isQuiet: isQuiet, isEmphasized: isEmphasized, isDisabled: isDisabled, isReadOnly: isReadOnly, validationState: validationState, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $011V3$useStyleProps)(otherProps);
    let domRef = (0, $011V3$useDOMRef)(ref);
    let ctx = {
        labelPosition: labelPosition,
        labelAlign: labelAlign,
        necessityIndicator: necessityIndicator
    };
    return /*#__PURE__*/ (0, $011V3$react).createElement("form", {
        ...(0, $011V3$filterDOMProps)(otherProps, {
            labelable: true,
            propNames: $ac118ceca79b8650$var$formPropNames
        }),
        ...styleProps,
        noValidate: true,
        ref: domRef,
        className: (0, $011V3$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports))), "spectrum-Form", {
            "spectrum-Form--positionSide": labelPosition === "side",
            "spectrum-Form--positionTop": labelPosition === "top"
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $011V3$react).createElement($ac118ceca79b8650$var$FormContext.Provider, {
        value: ctx
    }, /*#__PURE__*/ (0, $011V3$react).createElement((0, $011V3$Provider), {
        isQuiet: isQuiet,
        isEmphasized: isEmphasized,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        validationState: validationState
    }, children)));
}
/**
 * Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.
 */ const $ac118ceca79b8650$export$a7fed597f4b8afd8 = /*#__PURE__*/ (0, $011V3$react).forwardRef($ac118ceca79b8650$var$Form);




export {$ac118ceca79b8650$export$a6b5be5c6b451665 as useFormProps, $ac118ceca79b8650$export$a7fed597f4b8afd8 as Form};
//# sourceMappingURL=module.js.map
